class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
  this.cartItemKey = parsedState.key;

  this.getSectionsToRender().forEach((section) => {
    document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
      parsedState.sections[section.id],
      section.selector
    );
  });

  this.loadCartRecommendations(parsedState.product_id);

  if (this.header) this.header.reveal();
  this.open();
}
async loadCartRecommendations(lastAddedProductId) {
  const container = this.querySelector('#coc-popup-recommendations');
  const grid = container?.querySelector('.coc-popup-recommendations__grid');

  if (!container || !grid || !lastAddedProductId) return;

  const fallbackCards = Array.from(
    grid.querySelectorAll('.coc-popup-addon-card')
  );

  try {
    const cartResponse = await fetch(
      window.Shopify.routes.root + 'cart.js'
    );

    const cart = await cartResponse.json();

    const cartProductIds = new Set(
      cart.items.map((item) => String(item.product_id))
    );

    const contextProductIds = [
      String(lastAddedProductId),
      ...cart.items.map((item) => String(item.product_id))
    ]
      .filter((id, index, array) => array.indexOf(id) === index)
      .slice(0, 3);

    const selectedProducts = new Map();

    const fetchCards = async (productId, intent) => {
      const url =
        window.Shopify.routes.root +
        'recommendations/products' +
        '?section_id=cart-popup-recommendations' +
        '&product_id=' + encodeURIComponent(productId) +
        '&limit=10' +
        '&intent=' + intent;

      const response = await fetch(url);

      if (!response.ok) return [];

      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      return Array.from(
        html.querySelectorAll('.coc-popup-addon-card')
      );
    };

    const collectRecommendations = async (intent) => {
      const results = await Promise.all(
        contextProductIds.map((productId) =>
          fetchCards(productId, intent)
        )
      );

      for (const cards of results) {
        for (const card of cards) {
          const productId = card.dataset.productId;

          if (
            !productId ||
            cartProductIds.has(productId) ||
            selectedProducts.has(productId)
          ) {
            continue;
          }

          selectedProducts.set(productId, card);

          if (selectedProducts.size >= 3) return;
        }
      }
    };

    await collectRecommendations('complementary');

    if (selectedProducts.size < 3) {
      await collectRecommendations('related');
    }

    for (const fallbackCard of fallbackCards) {
      if (selectedProducts.size >= 3) break;

      const productId = fallbackCard.dataset.productId;

      if (
        productId &&
        !cartProductIds.has(productId) &&
        !selectedProducts.has(productId)
      ) {
        selectedProducts.set(productId, fallbackCard);
      }
    }

    let cards = Array.from(selectedProducts.values());

    const remaining = 7500 - cart.total_price;

    if (remaining > 0 && remaining <= 1000) {
      cards.sort((a, b) => {
        const priceA = Number(a.dataset.price || 0);
        const priceB = Number(b.dataset.price || 0);

        const reachesA = priceA >= remaining ? 0 : 1;
        const reachesB = priceB >= remaining ? 0 : 1;

        if (reachesA !== reachesB) {
          return reachesA - reachesB;
        }

        return (
          Math.abs(priceA - remaining) -
          Math.abs(priceB - remaining)
        );
      });
    }

    grid.innerHTML = '';

    cards.slice(0, 3).forEach((card) => {
      grid.appendChild(card);
    });
  } catch (error) {
    console.error('Cart recommendations could not load:', error);
  }
}

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
